export default "__VITE_ASSET__Ct2I8pcU__"